var n=function(n){return"auto"===n?"auto":0===n?"0":"".concat(.25*n,"rem")},t=function(){for(var t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];return t.reduce((function(t,r){return t?"".concat(t," ").concat(n(r)):n(r)}),"")};export{t as spacing};
//# sourceMappingURL=spacing.js.map
